import { Injectable } from '@angular/core';
import { Action, Actions, Selector, State, StateContext, Store } from '@ngxs/store';
import produce from 'immer';
import { Observable } from 'rxjs';
import { BrickSettingsService, CallControlBrickSettingRemoteDto } from '../../../../../../../generated/swagger';
import { IBrickSettingStateModel, SpecificBrickSettingsStateBase } from '../specific-brick-settings-base';
import { ChangeShowDialpad } from './call-control-settings.actions';

export interface CallControlSettingsStateModel extends IBrickSettingStateModel<CallControlBrickSettingRemoteDto> {}

function getDefaultSpecificBrickSetting(): CallControlBrickSettingRemoteDto {
   return {
      showDialpad: true,
      commonBrickSettingRemoteDto: null,
   };
}

@State<CallControlSettingsStateModel>({
   name: 'callControlSettings',
   defaults: {
      specificBrickSettings: {
         brickSettings: {},
         brickSettingsEditMode: null,
      },
   },
})
@Injectable()
export class CallControlSettingsState extends SpecificBrickSettingsStateBase<CallControlBrickSettingRemoteDto>(getDefaultSpecificBrickSetting) {
   constructor(private brickSettingsService: BrickSettingsService, store: Store, actions$: Actions) {
      super(store);
   }

   @Selector([CallControlSettingsState, CallControlSettingsState.getSettingModelFn])
   public static getIsDialpadShown(state, getSettingModelFn: (state, brickInstanceId) => CallControlBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showDialpad;
      };
   }

   @Action(ChangeShowDialpad)
   public changeShowDialpad(ctx: StateContext<CallControlSettingsStateModel>, action: ChangeShowDialpad) {
      const state = produce(ctx.getState(), (draft) => {
         const brickSettingModel = CallControlSettingsState.getSettingModelOrDefault(draft, action.brickInstanceId);
         brickSettingModel.showDialpad = action.showDialpad;
         draft.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
      });
      ctx.setState(state);
   }

   protected doSaveSpecificSettings(brickInstanceId: string, brickSetting: CallControlBrickSettingRemoteDto): Observable<any> {
      return this.brickSettingsService.changeCallBrickSettings({
         brickInstanceId: brickInstanceId,
         settings: brickSetting,
      });
   }
}
